// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinFilledSvg from "@ant-design/icons-svg/es/asn/SkinFilled";
import AntdIcon from '../components/AntdIcon';

var SkinFilled = function SkinFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkinFilledSvg
  }));
};

SkinFilled.displayName = 'SkinFilled';
export default React.forwardRef(SkinFilled);